<template>
  <el-popover
    ref="popoverRef"
    v-model:visible="visible"
    placement="right"
    trigger="click"
    :width="270"
    virtualTriggering
    :virtualRef="popRef"
    popperClass="template-guide-popover animate__bounceInRight"
    @after-leave="onPopoverHided"
    @show="saveGuideShow"
  >
    <template #default>
      <div v-click-outside="onClickOutside" class="tip-content">
        <div class="label">点击模板，即可一键创建专属应用</div>
        <div class="label">应用支持二次编辑，可灵活适配业务哦～</div>
        <div ref="closeIconRef" class="icon-close icon-close-white popover-close">
          <IconMyIconModalClose @click="onTipsClose"></IconMyIconModalClose>
        </div>
      </div>
    </template>
  </el-popover>
</template>

<script lang="ts" setup>
import { setLocalStoragePrivate } from '@/utils/storage-tools';
import { onMounted, PropType, ref, unref } from 'vue';
import { getGuideEmitter } from './guide.emitter';
import { LOCAL_STORAGE_ID, LOCAL_STORAGE_TEMPLATE_GUIDE } from './template-guide.constants';
import { ClickOutside as vClickOutside } from 'element-plus';
import { dwTemplateGuideCloseClick, dwTemplateGuideShow } from './guide-dw';

defineProps({
  popRef: {
    type: Object as PropType<HTMLElement>,
    require: true,
    default: undefined,
  },
});

const visible = ref(false);

const onTipsClose = () => {
  getGuideEmitter().emit('hide-template-guide');
  dwTemplateGuideCloseClick();
};

const saveGuideShow = () => {
  // 标记当前设备已显示指引
  setLocalStoragePrivate({ id: LOCAL_STORAGE_ID, key: LOCAL_STORAGE_TEMPLATE_GUIDE, data: { isShowed: 1 } });
};

const onShowEmitter = () => {
  getGuideEmitter().on('show-template-guide', () => {
    // 显示 popover
    visible.value = true;
    dwTemplateGuideShow();
  });
};

const onHideEmitter = () => {
  getGuideEmitter().on('hide-template-guide', () => {
    // 隐藏 popover
    visible.value = false;
  });
};

const popoverRef = ref();
const onClickOutside = () => {
  visible.value = false;
};

const emit = defineEmits<{ (event: 'on-destroy-tem-guide'): void }>();
const onPopoverHided = () => {
  emit('on-destroy-tem-guide');
  getGuideEmitter().emit('hide-template-guide');
};

onMounted(() => {
  onShowEmitter();
  onHideEmitter();
});
</script>

<style lang="scss" scoped>
.tip-content {
  position: relative;
  .label {
    height: 22px;
    font-size: 12px;
    color: #ffffff;
    line-height: 22px;
  }

  .popover-close {
    position: absolute;
    right: -2px;
    top: 0;
  }
}
</style>

<style lang="scss">
.el-popover.el-popper.template-guide-popover {
  box-sizing: border-box;
  padding: 10px 12px;
  border-radius: 4px;
  width: 270px;
  height: 64px;
  box-shadow: 0px 4px 8px 0px rgba(69, 103, 202, 0.3);
  border-radius: 4px;
  background-color: var(--lowcode-theme-common-01);
  border: 0;

  .el-popper__arrow::before {
    background-color: var(--lowcode-theme-common-01);
    border-color: var(--lowcode-theme-common-01);
  }

  .icon-close.icon-close-white path {
    fill: #fff;
  }
}

@keyframes bounceInRight {
  30% {
    opacity: 1;
    left: -40px;
  }

  to {
    left: 0;
  }
}

.animate__bounceInRight {
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-name: bounceInRight;
  animation-iteration-count: 2;
  animation-delay: 0.2s;
}
</style>
